import { windowWidth } from './utils';

const prodHeader = {
  wrap: document.getElementById('jsProdHeader') as HTMLElement | null,
  img: document.getElementById('jsImgWrap') as HTMLElement | null,

  init() {
    if (!this.wrap || !this.img) return;

    if (windowWidth < 1199) {
      this.setHeight();
      this.resize();
      this.reset();
    }
  },

  resize() {
    window.addEventListener('resize', () => {
      this.setHeight();
    });
  },

  reset() {
    window.addEventListener('reset', () => {
      this.setHeight();
    });
  },

  setHeight() {
    if (!this.wrap || !this.img) return;

    const getHeight = this.wrap.getBoundingClientRect().height;

    if (getHeight) {
      this.img.style.paddingTop = `${getHeight + 50}px`;
    }
  },
};

export default prodHeader;
